import classnames from 'classnames';
import * as React from 'react';
import './CenterContainer.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    middleClassName?: string;
    innerClassName?: string;
}

const CenterContainer: React.SFC<Props> =
    ({ className, middleClassName, innerClassName, children, ...rest }) => {
        return (
            <div className={classnames(className, 'Outer')} {...rest}>
                <div className={classnames(middleClassName || 'Middle')}>
                    <div className={classnames(innerClassName || 'Inner')}>
                        {children}
                    </div>
                </div>
            </div>
        );
    };

export default CenterContainer;
